<template>
  <div>
    <!-- 订单列表 -->
    <div class="table">
      <!-- 列表头部 -->
      <ol>
        <li class="flex05">NO</li>
        <!-- 店铺信息 -->
        <li class="flex15">
          {{ $t("message.storeInformation") }}
        </li>
        <!-- 照片 -->
        <li>
          {{ $t("message.pic") }}
        </li>
        <!-- 客户选择商品属性 -->
        <li class="flex2 important">
          {{ $t("message.theCustomerSelectsThePropertyOfTheItem") }}
        </li>
        <!-- 业务编辑商品属性 -->
        <li class="flex2 important">
          {{ $t("message.theBusinessEditsTheCommodityProperties") }}
        </li>
        <!-- 客户下单 -->
        <li>
          {{ $t("message.customerPlacesAnOrder") }}
        </li>
        <!-- 报价在库数-->
        <li class="flex15">
          {{ $t("message.quotedPrice") }}
        </li>
        <!-- 报价国内运费-->
        <li>
          {{ $t("message.quoteDomesticShipping") }}
        </li>
        <!-- 小计 -->
        <li>
          {{ $t("message.subtotal") }}.元
        </li>
        <!-- 附加服务 -->
        <li class="flex2 important">
          {{ $t("message.additionalServices") }}
        </li>
        <!-- 标签编号 -->
        <li class="flex2">
          {{ $t("message.tagNumber") }}
        </li>
        <!-- 客户单翻备注 -->
        <li class="flex2 important">
          {{ $t("message.customerSingleFlipRemarks") }}
        </li>
        <!-- 业务回复 -->
        <li class="flex2 important">
          {{ $t("message.businessReply") }}
        </li>
        <!-- 采购备注 -->
        <li class="flex2 important">
          {{ $t("message.purchasingNotes") }}
        </li>
        <!-- 业务翻译 -->
        <li class="flex2 important">
          {{ $t("message.businessTranslation") }}
        </li>
      </ol>
      <!-- list -->
      <ul v-for="(item, index) in detail" :key="index">
        <li class="flex05">{{ item.order_detail.sorting }}</li>
        <!-- 店铺信息 -->
        <li class="flex15">
          <div class="template">
            <p>{{ item.order_detail.shop_name }}</p>
            <p style="color: #15ad3c">{{ item.order_detail.from_platform }}</p>
            <p>{{ item.order_detail.shop_id }}</p>
          </div>
        </li>
        <!-- 照片 -->
        <li class="pic">
          <el-popover placement="right" width="300" trigger="hover">
            <img :src="item.order_detail.pic" alt="" style="width: 300px; height: 300px" />
            <a href="JavaScript:;" slot="reference" @click="openUrl(item)">
              <el-image :src="item.order_detail.pic" style="width: 60px; height: 60px; border-radius: 4px">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </a>
          </el-popover>
        </li>
        <!-- 客户下单商品属性 -->
        <li class="flex2 important">
          <div class="attribute">
            <el-tooltip placement="bottom">
              <div slot="content">
                <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail" :key="itemIndex"
                  style="margin-bottom: 5px">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
              <div>
                <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail" :key="itemIndex">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </li>
        <!-- 业务编辑属性 -->
        <li class="flex2 important">
          <div class="attribute">
            <el-tooltip placement="bottom">
              <div slot="content">
                <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex"
                  style="margin-bottom: 5px">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
              <div>
                <div class="row" v-for="(itemDetail, itemIndex) in item.order_detail.detail_y" :key="itemIndex">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </li>
        <!-- 客户 -->
        <li>
          <div class="template">
            <!-- 数量 -->
            <p>{{ $t("message.number") }}:{{ item.order_detail.num }}</p>
            <!-- 单价 -->
            <p>{{ $t("message.price") }}:{{ item.order_detail.price }}</p>
          </div>
        </li>
        <!-- 报价-->
        <li class="flex15">
          <div class="template">
            <p>{{ $t("message.inStock") }}:{{ item.order_detail.confirm_num }}</p>
            <p>{{ $t("message.price") }}:{{ item.order_detail.confirm_price }}</p>
          </div>
        </li>
        <!-- 报价国内运费-->
        <li>{{ item.order_detail.confirm_freight }}</li>
        <!-- 客户小计 -->
        <li>
          {{
            item.order_detail.confirm_num * item.order_detail.confirm_price + (item.order_detail.confirm_freight - 0)
          }}
        </li>
        <!-- 附加服务 -->
        <li class="flex2 important">
          <div class="attribute services">
            <el-tooltip placement="bottom">
              <div slot="content">
                <div class="row" v-for="(opti, optiIndex) in item.order_detail.option" :key="optiIndex"
                  style="margin-bottom: 3px">
                  <p>
                    {{ optiIndex + 1 }}.{{ opti.name }}:
                    <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                    <span v-else> {{ opti.price }}% </span>
                  </p>
                </div>
              </div>
              <div style="height: 100px">
                <div class="row" v-for="(opti, optiIndex) in item.order_detail.option" :key="optiIndex">
                  <p>
                    {{ optiIndex + 1 }}.{{ opti.name }}:
                    <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                    <span v-else> {{ opti.price }}% </span>
                  </p>
                </div>
              </div>
            </el-tooltip>
          </div>
        </li>
        <!-- 标签编号 -->
        <li class="flex2">
          类别:XXXX 标签号:12345678901234 商品码:ASIN码 44546
        </li>
        <!-- 客户商品备注 -->
        <li class="flex2 important">
          <div class="text">{{ item.order_detail.client_remark }}</div>
        </li>
        <!-- 业务回复 -->
        <li class="flex2 important">
          <span> {{ item.order_detail.y_reply }} </span>
        </li>
        <!-- 采购备注 -->
        <li class="flex2 important">
          <span> {{ item.order_detail.g_remark }} </span>
        </li>
        <!-- 业务翻译 -->
        <li class="flex2 important">
          <span> {{ item.order_detail.y_remark }} </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Array },
  },
  data() {
    return {};
  },
  methods: {
    //url跳转
    openUrl(item) {
      if (item.from_platform == "1688") {
        window.open(
          `https://detail.1688.com/offer/${item.goods_id}.html?`,
          "_blank"
        );
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  font-size: 12px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;

    &:hover {
      background-color: #fff;
    }

    .template {
      text-align: center;

      p {
        margin-bottom: 5px;
      }
    }

    .attribute {
      text-align: left;
      width: 100%;
      padding: 3%;

      .row {
        width: 100%;
        margin-bottom: 5px;
      }
    }

    .services {
      text-align: left;
    }

    .text {
      padding: 5px;
    }

    .el-textarea {
      height: 100%;
    }

    /deep/.el-textarea__inner {
      padding: 5px;
      min-height: 63px !important;
      height: 100% !important;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /deep/.el-input__inner {
      padding: 0;
      text-align: center;
    }

    .pic {
      position: relative;
    }

    .edit {
      width: 20px;
      height: 20px;
      margin-left: 5px;

      i {
        font-size: 20px;
        color: #2c96e7;
        cursor: pointer;
      }
    }
  }
}
</style>